import { useCreateGoal } from '_api';
import { GoalPayload } from '_api/types';
import { SEVERITY } from '_constants/derived';
import { DefaultNewGoal } from '_constants/object-templates';
import { AlertMessage, BaseModal } from 'components/molecules';
import { GoalForm } from 'components/organisms/forms';
import React, { useState } from 'react';

import { GoalModalProps } from './types';

export const AddGoalModal = ({
  hasLongTermGoal,
  open,
  onClose,
  patientId,
}: GoalModalProps) => {
  const { mutateAsync: createGoal } = useCreateGoal();
  const [errorMessage, setErrorMessage] = useState('');
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const onSubmit = (submitGoal: GoalPayload) => {
    const newGoal = { ...submitGoal, patientId };
    createGoal(newGoal)
      .then((data) => {
        if (data && data.id) {
          setShowSuccess(true);
          setTimeout(() => {
            onClose();
          }, 1500);
        }
      })
      .catch((err) => {
        setErrorMessage(err.message);
        setShowError(true);
      });
  };

  return (
    <BaseModal open={open} onClose={onClose} title={'Goal'}>
      <GoalForm
        hasLongTermGoal={hasLongTermGoal}
        initValue={DefaultNewGoal}
        onBack={onClose}
        onSubmit={onSubmit}
      />
      <AlertMessage
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={'Goal successfully created'}
      />
      <AlertMessage
        open={showError}
        onClose={() => setShowError(false)}
        severity={SEVERITY.error}
        message={
          <>
            Failed to create Goal.
            <br />
            {errorMessage}
            <br />
            Resolve form issues and try again.
          </>
        }
      />
    </BaseModal>
  );
};
